export default {
    log (label, data) {
        if (process.env.NODE_ENV === 'development') {
            if (!data) {
                console.log(label)
            } else {
                console.log(label, data)
            }
        }
    },
    info (label, data) {
        if (process.env.NODE_ENV === 'development') {
            if (!data) {
                console.info(label)
            } else {
                console.info(label, data)
            }
        }
    },
    error (label, data) {
        if (process.env.NODE_ENV === 'development') {
            if (!data) {
                console.error(label)
            } else {
                console.error(label, data)
            }
        }
    }
}
